import 'browsernizr/test/touchevents';
import HTML5Backend from 'react-dnd-html5-backend';

const DragDropBackend = HTML5Backend; // Just THML5 backend for now, try and support touch devices later, there are some quirks: Modernizr.touchevents ? TouchBackend : HTML5Backend;

export default DragDropBackend;
